// Aligneo signature cursor — amber dot + cream trailing ring.

export function initCursor() {
    const inner = document.getElementById("cur");
    const outer = document.getElementById("cur-outer");
    if (!inner || !outer) return;

    const supportsHover =
        window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!supportsHover || reduced) return;

    document.body.classList.add("has-custom-cursor");

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let ox = mx;
    let oy = my;
    let raf;

    const tick = () => {
        ox += (mx - ox) * 0.18;
        oy += (my - oy) * 0.18;
        inner.style.left = `${mx}px`;
        inner.style.top = `${my}px`;
        outer.style.left = `${ox}px`;
        outer.style.top = `${oy}px`;
        raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    const onMove = (e) => {
        mx = e.clientX;
        my = e.clientY;
        if (inner.style.opacity !== "1") {
            inner.style.opacity = "1";
            outer.style.opacity = "1";
        }
    };

    const onLeave = () => {
        inner.style.opacity = "0";
        outer.style.opacity = "0";
    };

    const onOver = (e) => {
        const t = e.target;
        const isInteractive =
            t.closest && t.closest('a, button, [role="button"], input, textarea, label');
        const isText =
            t.closest && t.closest(
                'input[type="text"], input[type="email"], input[type="tel"], input[type="search"], textarea',
            );
        inner.classList.toggle("is-pointer", !!isInteractive && !isText);
        outer.classList.toggle("is-pointer", !!isInteractive && !isText);
        inner.classList.toggle("is-text", !!isText);
        outer.classList.toggle("is-text", !!isText);
    };

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseleave", onLeave);
}
